import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SearchMinusIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.4 10.56C17.4 12.3 16.76 13.92 15.68 15.16L20 19.48L18.68 20.8L14.3 16.42C13.14 17.24 11.72 17.72 10.2 17.72C6.26 17.72 3 14.48 3 10.56C3 6.64 6.26 3.4 10.2 3.4C14.14 3.4 17.4 6.64 17.4 10.56ZM4.88 10.56C4.88 13.5 7.26 15.92 10.2 15.92C13.14 15.92 15.52 13.5 15.52 10.56C15.52 7.62 13.14 5.2 10.2 5.2C7.26 5.2 4.88 7.62 4.88 10.56ZM13.54 11.48H6.86V9.68H13.54V11.48Z" />
    </SvgIcon>
  );
});
